import { createApp, vModelText } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "./assets/style.css";
// import Markdown from 'vue3-markdown-it';
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'

import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import enUS from '@kangc/v-md-editor/lib/lang/en-US';
import hljs from 'highlight.js';
VueMarkdownEditor.use(githubTheme, {
  Hljs: hljs,
}
);
VueMarkdownEditor.lang.use('en-US', enUS);
import createMermaidPlugin from '@kangc/v-md-editor/lib/plugins/mermaid/cdn';
import '@kangc/v-md-editor/lib/plugins/mermaid/mermaid.css';


VueMarkdownEditor.use(createMermaidPlugin({
  mermaidInitializeOptions: {
    securityLevel: 'antiscript'
  }
}));

import createTipPlugin from '@kangc/v-md-editor/lib/plugins/tip/index';
import '@kangc/v-md-editor/lib/plugins/tip/tip.css';

VueMarkdownEditor.use(createTipPlugin());

import createAlignPlugin from '@kangc/v-md-editor/lib/plugins/align';

VueMarkdownEditor.use(createAlignPlugin());

import VMdPreview from '@kangc/v-md-editor/lib/preview';



import '@kangc/v-md-editor/lib/style/preview.css';
// import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';


VMdPreview.use(githubTheme, {
  Hljs: hljs,
});
// VMdPreview.lang.use('en-US', enUS);
VMdPreview.use(createMermaidPlugin({
  mermaidInitializeOptions: {
    securityLevel: 'antiscript'
  }
}));
VMdPreview.use(createTipPlugin());
VMdPreview.use(createAlignPlugin());
//set lang

loadFonts();

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
Amplify.configure(awsExports);

createApp(App).use(router).use(vuetify).use(VueMarkdownEditor).use(VMdPreview).mount("#app");
